import {
    AutocompleteInput,
    DateInput,
    TextInput,
    required,
    useGetList,
} from 'react-admin';
import { SimpleForm } from '@components/SimpleForm';
import { Grid } from '@mui/material';
import { entityResource as ent } from '@src/entityResource';
import { toInt, format } from '@helpers/numeric.ext';

export const StoreForm = () => {
    const days = [
        { id: 0, name: 'Minggu' },
        { id: 1, name: 'Senin' },
        { id: 2, name: 'Selasa' },
        { id: 3, name: 'Rabu' },
        { id: 4, name: 'Kamis' },
        { id: 5, name: 'Jumat' },
        { id: 6, name: 'Sabtu' },
    ];

    const { data: sales, isPending } = useGetList(ent.USER.SALES_API);
    return (
        <SimpleForm>
            <Grid container spacing={2}>
                <Grid item xs={12} md={7}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={4}>
                            <AutocompleteInput
                                source="visitDay"
                                choices={days}
                            />
                        </Grid>
                        <Grid item xs={12} md={8}>
                            <AutocompleteInput
                                source="userId"
                                optionText="name"
                                optionValue="id"
                                isPending={isPending}
                                choices={sales}
                            />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <TextInput source="name" validate={[required()]} />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextInput
                                source="latitude"
                                validate={[required()]}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextInput
                                source="longitude"
                                validate={[required()]}
                            />
                        </Grid>
                        <Grid item xs={12} md={8}>
                            <TextInput source="address" multiline />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextInput source="phone" />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextInput
                                source="creditLimit"
                                defaultValue={0}
                                format={v => format(v)}
                                parse={v => toInt(v)}
                                resettable={true}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <DateInput source="creditEffDtFrom" />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <DateInput source="creditEffDtTo" />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={5}>
                    <Grid container>
                        <Grid item xs={12} md={12}>
                            {/* embed google map */}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </SimpleForm>
    );
};
